import { Html, html, View } from 'rune-ts';
import { font } from '@services/MarppleShop/shared/typography';
import { doIf } from '@services/MarppleShop/shared/util';
import {
  FormFieldControl,
  InputEditor,
} from '@services/MarppleShopStudio/shared/component/atom/Input/core/types.ts';
import klass from './input.module.scss';
import { required_html } from '@services/MarppleShopStudio/shared/component/atom/Input/core/helper.ts';

export abstract class Input_Base<T extends Partial<InputEditor>> extends View<T> implements FormFieldControl {
  override template() {
    return html`
      <div class="${klass.input_root}">
        <div class="${klass.title_wrap}">
          <div class="${klass.title} ${this.data.title_klass ?? ''}">
            <span class="${this.data.font_klass ?? font('14_bold')}">${this.data.title}</span>
            ${doIf(() => {
              return required_html;
            }, !!this.data.required)}
          </div>
          ${this.titleRightHtml()}
        </div>
        ${this.inputTemplate()}
      </div>
    `;
  }

  protected abstract inputTemplate(): Html | View;

  public titleRightHtml() {
    return html``;
  }

  public abstract setError(is_error: boolean, message?: string, name?: string): void;
  public abstract getName(): string;
  public abstract getValue(): unknown;
}
